import { NodeReference } from '../decorators';
import { instanceOfAny } from '../decorators/model-utils';
import { IPatternFeature } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { SketchNode } from '../meshes';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature } from './feature';

export abstract class PatternFeature extends Feature implements IPatternFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    @NodeReference(SketchNode) meshId: string;
    count: number;
    distance: number;
    addEndMesh: boolean;
}

export function isPattern(o: Kb3dObject): o is PatternFeature {
    return instanceOfAny(o, Token.LinearPatternFeature, Token.CircularPatternFeature);
}
